import { Page } from 'framework7-react';
import { FC } from 'react';
import { ServicesAll } from './ServicesAll/ServicesAll';

export const ServicesAllPage: FC = () => {
  return (
    <Page name="servicesAll">
      <ServicesAll />
    </Page>
  );
};
